import React from "react";
import { useI18n, LANGS } from "@/i18n";
import { Globe } from "lucide-react";
import { DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuTrigger } from "@/components/ui/dropdown-menu";

export function LanguageSelector({ dark = false }) {
  const { lang, setLang } = useI18n();
  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <button data-testid="language-selector" className={`inline-flex items-center gap-1.5 text-xs font-medium tracking-wide ${dark ? "text-white/80 hover:text-white" : "text-ink/70 hover:text-ink"}`}>
          <Globe className="h-4 w-4" /> {lang.toUpperCase()}
        </button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" className="rounded-sm">
        {LANGS.map((l) => (
          <DropdownMenuItem key={l.code} data-testid={`lang-option-${l.code}`} onClick={() => setLang(l.code)} className="text-sm cursor-pointer">
            <span className="w-8 font-mono text-xs text-heraldic">{l.code.toUpperCase()}</span> {l.label}
          </DropdownMenuItem>
        ))}
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
